module.exports = __webpack_public_path__ + "static/media/Add_to_Apple_Wallet.6fc3081f.svg";